import { FC } from "react";

import { PagesCard } from "./detail/PagesCard";

import { HideUnlessEditModeButton } from "components/materials/HideUnlessEditModeButton";
import { t } from "i18n/i18n";
import { Card } from "mds/components/Card";
import { useCapabilities } from "store/capability-hooks";
import { selectPagesByActivityId } from "store/selectors";
import { useListSelector } from "store/store-hooks";
import { PAGE_LIST_ITEM_FIELDS, usePageActions } from "utils/page";

type PrepWorkActivityCardProps = {
  activityId: string;
};

/** This component is for displaying the prep work activity for a topic.
 *  There should always be 1 prep work activity per topic, and this activity
 *  cannot be renamed or deleted. There is no time estimate for a prep work activity.
 */
export const PrepWorkActivityCard: FC<PrepWorkActivityCardProps> = ({ activityId }) => {
  const { canAuthorSection } = useCapabilities();
  const pages = useListSelector(
    (s) => selectPagesByActivityId(s, activityId),
    PAGE_LIST_ITEM_FIELDS,
  );

  const { createPage } = usePageActions();

  const createNewPage = () => {
    createPage("activity_page", activityId);
  };

  return (
    <>
      <PagesCard
        activityId={activityId}
        canManagePages={canAuthorSection}
        header={t("topic_sidebar.prep_work")}
        pages={pages}
        addTopicParam
      />

      {canAuthorSection && pages.length === 0 && (
        <Card className="mb-3 mt-2" small>
          <div className="-ml-1">
            <HideUnlessEditModeButton reference="page" onClick={createNewPage} />
          </div>
        </Card>
      )}
    </>
  );
};
